<template>
  <div class="active-table__actions-dropdown">
    <el-dropdown trigger="click">
      <span class="el-dropdown-link" @click.stop>
        <i class="active-table__actions-dropdown__drop-icon el-icon-more"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          class="active-table__actions-dropdown__item"
          v-for="action in actions"
          :key="action.name"
        >
          <a @click="onClick(action)">
            <ui-inline-icon class="active-table__actions-dropdown__item-icon" :icon="action.icon"></ui-inline-icon>
            <span>{{action.name}}</span>
          </a>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
  export default {
    name: 'ActionsDropdown',
    props: {
      actions: {},
      row: {}
    },
    methods: {
      async onClick (action) {
        if (await action.handler(this.row)) {
          this.$emit('reload')
        }
      }
    }
  }
</script>

<style lang="scss">
  .active-table__actions-dropdown {
    &__item-icon {
      justify-content: center;
      display: flex !important;
      align-items: center;

      path[fill] {
        fill: #909399;
      }

      path[stroke] {
        stroke: #909399;
      }
    }

    &__item {
      a {
        display: grid;
        grid-template-columns: 24px 1fr;
        grid-column-gap: 12px;
        align-items: center;

        &:hover {
          color: #2F80ED !important;
        }
      }
    }

    &__drop-icon {
      color: #C0C4CC;
      font-size: 20px;

      &:focus {
        outline: 0;
        border: none;
      }
    }
  }
</style>